import { ReactQueryDevtools } from '@tanstack/react-query-devtools';

const DevelopmentUtils = () => {
  if (process.env.NODE_ENV === 'production') return null;
  return (
    <>
      <ReactQueryDevtools initialIsOpen={false} />
    </>
  );
};

export default DevelopmentUtils;
